/**
 * Loaded only on the `product.miswak` template.
 * Intercepts the product form submit (including Appstle's selling_plan field), adds the
 * item via /cart/add.js while preserving quantity + selling_plan, then redirects to the
 * upsell page. Falls back to the native form submit if the fetch fails for any reason,
 * so checkout is never blocked by this script.
 */
(function () {
  var REDIRECT_URL = '/pages/special-offer';
  var handledForms = new WeakSet();

  function findAddToCartForms() {
    return Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"], product-form form'));
  }

  function getFormData(form) {
    var formData = new FormData(form);
    // Ensure quantity is present (Craft's quantity input lives outside the <form> in some
    // layouts but references it via the `form` attribute — FormData(form) only picks up
    // fields whose form owner is this form, so also scan external inputs bound via [form].
    var externalInputs = document.querySelectorAll('[form="' + form.id + '"]');
    externalInputs.forEach(function (input) {
      if (!input.name) return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) formData.set(input.name, input.value);
      } else {
        formData.set(input.name, input.value);
      }
    });

    if (!formData.has('quantity')) {
      formData.set('quantity', '1');
    }

    return formData;
  }

  function submitViaAjax(form, formData) {
    var payload = {};
    formData.forEach(function (value, key) {
      // /cart/add.js expects id + quantity + properties/selling_plan at top level
      if (key === 'id') payload.id = value;
      else if (key === 'quantity') payload.quantity = parseInt(value, 10) || 1;
      else if (key === 'selling_plan' && value) payload.selling_plan = value;
      else if (key.indexOf('properties[') === 0) {
        payload.properties = payload.properties || {};
        var propKey = key.replace('properties[', '').replace(']', '');
        payload.properties[propKey] = value;
      }
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) {
          throw new Error((err && err.description) || 'Add to cart failed');
        });
      }
      return response.json();
    });
  }

  function attach(form) {
    if (handledForms.has(form)) return;
    handledForms.add(form);

    form.addEventListener('submit', function (event) {
      // Let a real add-to-cart submission through only via our AJAX path.
      event.preventDefault();

      var formData = getFormData(form);
      var submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      submitViaAjax(form, formData)
        .then(function () {
          window.location.href = REDIRECT_URL;
        })
        .catch(function () {
          // Fallback: let the native submit proceed normally (standard cart flow),
          // so a script or network failure never blocks checkout.
          if (submitButton) submitButton.disabled = false;
          handledForms.delete(form);
          form.submit();
        });
    });
  }

  function boot() {
    findAddToCartForms().forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-scan if the product form is re-rendered dynamically (e.g. variant change re-render).
  document.addEventListener('product-form:re-render', boot);
})();
